<template>
  <modal :visible="$props.visible"
         :close-visible="false"
         prevent-backdrop-close
         class="replacement-dialog"
         @modal-close="$emit('close')">
    <div slot="body" class="replacement-body">
      <h2 class="title">{{ $t('checkout.cartOverview.replaceSubsidyTitle') }}</h2>
      <p class="description">{{ $t('checkout.cartOverview.replaceSubsidyDescription') }}</p>
      <div class="product-section">
        <img class="product-image"
             :src="productImage"
             alt=""/>
        <div class="product-info">
          <h4>{{ productBrand }}</h4>
          <h3>{{ productName }}</h3>
        </div>
        <div class="product-price">
          <p class="price-label">{{ $t('checkout.cartOverview.monthlyLabel') }}</p>
          <h3 class="price"><span class="recurring-months">{{ prices.months }}x</span> {{ prices.price }} <span
            class="currency">{{ $t('common.currency') }}</span></h3>
        </div>
      </div>
      <div class="actions-section">
        <base-button class="action-button"
                     :loading="dataLoading"
                     @click="replaceSubsidyPrice">
          {{ $t('common.continueShopping') }}
        </base-button>
        <base-button variant="secondary"
                     class="action-button"
                     @click="$emit('cancel')">
          {{ $t('common.abort') }}
        </base-button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../common/modal/modal'
import BaseButton from '../../base/base-button'
import { getCookie } from '@/utils/cookieController'
import { replaceSubsidy } from '../../../api/cart'

export default {
  name: 'product-replacement-dialog',
  components: { Modal, BaseButton },
  data () {
    return {
      dataLoading: false
    }
  },
  props: {
    visible: Boolean,
    productInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    productImage () {
      return this.$props.productInfo?.product?.images[0]?.url
    },
    productBrand () {
      return this.$props.productInfo?.product?.brands[0].name
    },
    productName () {
      return this.$props.productInfo?.product?.name
    },
    prices () {
      return {
        months: this.$props.productInfo?.monthlyPrice?.cycleEnd,
        price: this.$props.productInfo?.monthlyPrice?.price?.formattedValue
      }
    }
  },
  methods: {
    replaceSubsidyPrice () {
      this.dataLoading = true
      const cartId = getCookie('guid')
      const dataToSend = {
        cartId: cartId,
        pricePlanId: this.$props.productInfo.priceId,
        replace: true,
        variantProductCode: this.$props.productInfo.variant.code
      }

      replaceSubsidy(dataToSend)
        .then(({ data }) => {
          this.$emit('refresh-cart', data)
        })
        .catch(e => {
          this.toast('error', {
            message: this.$t('errors.defaultError')
          })
        })
        .finally(() => {
          this.dataLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
@mixin flexVCenterColumn {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.replacement-dialog {
  overflow-y: auto;
}

.replacement-body {
  text-align: center;
  color: $text;
  padding: 3.2rem;

  .title {
    font-size: 2.4rem;
    font-weight: normal;
    margin-bottom: 1.6rem;
  }

  .description {
    font-size: 1.6rem;
    color: $dark-grey;
    margin-bottom: 3.2rem;
  }

  .product-section {
    width: 100%;
    margin: auto;
    text-align: left;
    background-color: $grey;
    border-radius: 0.5rem;
    padding: 2.4rem 3.2rem;
    display: flex;
    flex-direction: column;

    @media (map_get($breakpoints, sm)) {
      max-width: 56.2rem;
      flex-direction: row;
      flex-wrap: nowrap;
    }

    .product-image {
      width: 100%;
      max-width: 15.6rem;
      margin: auto;

      @media (map_get($breakpoints, sm)) {
        height: 12.8rem;
        width: auto;
        margin-right: 2.4rem;
      }
    }

    .product-info {
      margin-top: 1.6rem;
      @media (map_get($breakpoints, sm)) {
        margin-top: 0;
        flex: 1 1 auto;
        padding-right: 4rem;
        border-right: 1px solid rgba($text, 0.1);
        @include flexVCenterColumn;
      }

      h4 {
        font-size: 1.2rem;
        text-transform: uppercase;
        line-height: 1.67;
        margin: 0;
      }

      h3 {
        font-size: 1.8rem;
        margin: 0;
      }
    }

    .product-price {
      margin-top: 1.6rem;
      @media (map_get($breakpoints, sm)) {
        margin-top: 0;
        padding-left: 4rem;
        flex-basis: 35%;
        @include flexVCenterColumn;
      }

      .price-label {
        font-size: 1.2rem;
        margin: 0;
        color: $dark-grey;
      }

      .price {
        font-size: 2rem;
        color: $primary;
      }

      .recurring-months, .currency {
        font-size: 1.4rem;
        color: $text;
      }
    }
  }

  .actions-section {
    text-align: center;
    margin-top: 4rem;

    .action-button {
      width: 100%;
      margin: 0.8rem 0;

      @media (map_get($breakpoints, sm)) {
        margin: 0 1.6rem;
        max-width: 24rem;
      }
    }
  }
}
</style>
